<!-- eslint-disable eqeqeq -->
<template>
  <div>
    <!-- <el-input
      tabindex="-1"
      type="text"
      style="visibility: hidden; width: 0; height: 0; padding: 0"
    /> -->
    <div v-if="label" class="select-with-search__label label">
      <label>{{ label }}</label>
    </div>

    <div
      v-click-outside="() => (showDropdown = false)"
      class="select-with-search"
      :class="[
        {
          disabled: disabled
        },
        `select-with-search__${size}`
      ]"
    >
      <div class="select__control" @click="onClickWrapper">
        <div class="select__value">
          <slot name="value" :selectedValue="selectedData" />
        </div>
        <div class="select__indicator">
          <template v-if="selectedIndexFieldValue && isRemoveBtn">
            <div
              class="select__clear-indicator"
              @click.stop="removeSelectedRow"
            >
              <i class="el-icon-close" />
            </div>
            <div class="select__indicator-separator" />
          </template>
          <div class="select__dropdown-indicator">
            <i class="el-icon-caret-bottom" />
          </div>
        </div>
      </div>

      <!-- Dropdown -->
      <div
        v-show="showDropdown"
        ref="dropdown"
        class="select__dropdown-wrapper"
        :style="{ width: dropdownWidth }"
      >
        <input
          v-model="filterText"
          class="select__search-field"
          type="text"
          :placeholder="searchPlaceHolder"
          @input="onInput"
        />
        <div style="height: 350px" class="select__table-wrapper">
          <GridVx
            ref="agGrid"
            dom-layout="scroll"
            :columns="columns"
            :rows="filterRows"
            row-selection="single"
            class="agGrid"
            :auto-select-first-row="false"
            @selectionChanged="onSelectionChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clickOutSide from '@/directive/click-outside/index'

export default {
  directives: {
    'click-outside': clickOutSide
  },
  props: {
    label: {
      default: '',
      type: String
    },
    searchFields: {
      type: Array,
      default: () => []
    },
    searchPlaceHolder: {
      type: String,
      default: 'Nhập thông tin tìm kiếm'
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    rows: {
      type: Array,
      required: true,
      default: () => []
    },
    // The field in the row data to be used as an index (for filter)
    indexField: {
      type: String,
      required: true
    },
    // The value of the selected index field.
    selectedIndexFieldValue: {
      type: [String, Number],
      default: null
    },
    isRemoveBtn: {
      default: false,
      type: Boolean
    },
    dropdownWidth: {
      type: String,
      default: '100%'
    },
    /**
     * @type {[String, Number]}
     * @description To use with Vee-validate
     */
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: function (val) {
        return ['medium', 'small', 'mini'].includes(val)
      }
    }
  },
  data() {
    return {
      showDropdown: false,
      filterText: '',
      filterRows: [],
      selectedData: {}
    }
  },
  watch: {
    showDropdown(val) {
      if (!val) {
        this.filterRows = [...this.rows]
        this.filterText = ''
      } else {
        if (this.selectedIndexFieldValue) {
          this.setSelectedRow(this.selectedIndexFieldValue)
        }
      }
    },
    rows(val) {
      this.filterRows = [...val]
      this.fnGetSelectedRow()
    },
    selectedIndexFieldValue(val) {
      this.fnGetSelectedRow()
    }
  },
  mounted() {
    this.filterRows = [...this.rows]
    this.gridApi = this.$refs.agGrid.gridApi
    this.fnGetSelectedRow()
  },
  methods: {
    fnSetSelectedRow(val) {
      this.selectedData = val
      this.$emit('selectionChanged', val)
      // this.setSelectedRow
    },

    fnGetSelectedRow() {
      let selectedRow = null
      if (this.selectedIndexFieldValue) {
        selectedRow = this.rows.find(row => {
          // eslint-disable-next-line eqeqeq
          return row?.[this.indexField] === this.selectedIndexFieldValue
        })
        // this.fnSetSelectedRow(selectedRow)
      }
      this.selectedData = selectedRow
    },
    onSelectionChanged(rows) {
      const rowSelected = rows[0]
      this.fnSetSelectedRow(rowSelected)
      // this.showDropdown = false
    },
    onInput(e) {
      const text = e.target.value.toLowerCase()

      if (this.searchFields.length) {
        this.filterRows = this.rows.filter(row =>
          this.searchFields.some(field => {
            const fieldVal = row[`${field}`]
            return fieldVal?.toString().toLocaleLowerCase().includes(text)
          })
        )
      } else {
        this.filterRows = this.rows.filter(row =>
          Object.values(row).some(value => {
            if (value === null || value === undefined) {
              return false
            }

            return value.toString().toLocaleLowerCase().includes(text)
            // value?.toLowerCase().includes(filterTextLowerCase)
          })
        )
      }
    },
    onClickWrapper(e) {
      if (!this.disabled) {
        this.showDropdown = !this.showDropdown
      }
      // console.log('Toggle show')
    },
    onBlurWrapper() {
      this.showDropdown = false
      // console.log('Hide')
    },

    setSelectedRow(fieldVal) {
      this.gridApi.forEachNode(node => {
        // eslint-disable-next-line eqeqeq
        if (node.data?.[this.indexField] == fieldVal) {
          node.setSelected(true)
          return
        }
      })
    },
    removeSelectedRow() {
      this.fnSetSelectedRow(null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
// .select-with-search__label {
//   font-size: 14px;
//   color: #606266;
// }

.select-with-search {
  position: relative;
  width: 100%;
  height: 36px;
  background: white;
  border-radius: 4px;
  border: 1px solid rgb(220, 223, 230);

  &.select-with-search__medium {
    height: 36px;
  }

  &.select-with-search__small {
    height: 32px;
  }

  &.select-with-search__mini {
    height: 28px;
  }

  &.disabled {
    background-color: $bg-disabled;
  }

  .select__control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding-left: 15px;
    cursor: pointer;

    .select__value {
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 0.875rem;
    }

    .select__indicator {
      display: flex;
      height: 100%;
      align-items: center;

      .select__indicator-separator {
        width: 1px;
        background-color: #ddd;
        height: 70%;
      }

      .select__clear-indicator,
      .select__dropdown-indicator {
        padding: 10px;
        line-height: 1rem;

        i {
          color: #a7a7a7;
        }

        &:hover {
          i {
            color: #5c5c5c;
          }
        }
      }

      .select__clear-indicator {
      }
      .select__dropdown-indicator {
      }
    }
  }

  // .select__value {
  //   width: 100%;
  //   height: 100%;
  //   line-height: 36px;
  //   padding: 0 15px;
  //   font-size: 0.825rem;
  // }

  // .select__suffix {
  //   position: absolute;
  //   right: 10px;
  //   // width: 25px;
  //   top: 0;
  //   bottom: 0;

  //   .select__suffix-inner {
  //     // display: inline-block;
  //     line-height: 36px;
  //     // text-align: center;

  //     width: 55px;
  //   display: flex;
  //   justify-content: space-between;
  //   }
  // }

  &::before {
    display: block;
    content: '';
    width: 100%;
    height: 14px;
    position: absolute;
    bottom: -10px;
  }
}

.select__dropdown-wrapper {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 250px;
  // min-width: 80%;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding-bottom: 8px;
  max-height: 400px;
  overflow: hidden;
  background-color: #fff;
  z-index: 10;

  .select__search-field {
    font-size: 0.875rem;
    width: 100%;
    height: 36px;
    padding: 4px 10px;
    border: none;
    outline: none;
  }
}
</style>
